import BasicRecord from "./utils/BasicRecord";

const NATIVE_MAC_APP_SOURCE = "macApp";

function isDialogSourceNativeMacApp(urlParams: BasicRecord<string | string[] | undefined>): boolean {
    const { source } = urlParams;
    if (typeof source === "string") {
        return source === NATIVE_MAC_APP_SOURCE;
    }

    if (Array.isArray(source)) {
        return source[0] === NATIVE_MAC_APP_SOURCE;
    }

    return false;
}

export {
    NATIVE_MAC_APP_SOURCE,
    isDialogSourceNativeMacApp
};
